import { composables } from "@orange-marmalade/paginate-this";
import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission";

export const relatedCompanyPageActions = composables({
  listId: "company/relatedCompanies"
});

export function createRelatedCompany(relatedCompany) {
  return (dispatch, getState) => {
    const companyId = getState().companyDetail.getIn(["company", "id"]);
    return api.companies.relatedCompanies
      .create(companyId, relatedCompany)
      .then(() => {
        dispatch(relatedCompanyPageActions.expire());
        return SUCCESS;
      });
  };
}

export function updateRelatedCompany(relatedCompany) {
  return dispatch =>
    api.relatedCompanies.update(relatedCompany).then(() => {
      dispatch(relatedCompanyPageActions.expire());
      return SUCCESS;
    });
}

export function destroyRelatedCompany(id) {
  return dispatch =>
    api.relatedCompanies
      .destroy(id)
      .then(() => dispatch(relatedCompanyPageActions.expire()));
}



// WEBPACK FOOTER //
// ./app/modules/companies/actions/RelatedCompanies/actions.js